/*eslint no-underscore-dangle:0*/
define('glu/glu',['require','backbone','marionette','respond','bootstrap.tooltip','bootstrap.affix','bootstrap.alert','bootstrap.button','bootstrap.collapse','bootstrap.transition','bootstrap.dropdown','bootstrap.popover','bootstrap.scrollspy','bootstrap.modal','bootstrap.tab','./combobox'],function(require) {
    'use strict';

    /**
     * This module pulls in baseline dependencies, such as jQuery plugins to support UI fundamentals, like dropdowns
     */

    var Backbone = require('backbone'),
        Marionette = require('marionette');

    // https://github.com/marionettejs/marionette.inspector#caveats
    if (window.__agent) {
        window.__agent.start(Backbone, Marionette);
    }

    // Support width media queries in IE8
    require('respond');

    // jQuery plugins
    require('bootstrap.tooltip');
    require('bootstrap.affix');
    require('bootstrap.alert');
    require('bootstrap.button');
    require('bootstrap.collapse');
    require('bootstrap.transition');
    require('bootstrap.dropdown');
    require('bootstrap.popover');
    require('bootstrap.scrollspy');
    require('bootstrap.modal');
    require('bootstrap.tab');

    // Combobox (Select2)
    require('./combobox');

    return {
        VERSION: '1.8.39',
        Backbone: Backbone,
        Marionette: Marionette,
        History: Backbone.History,
        history: Backbone.history
    };
});

